import styled from 'styled-components/macro'
import { color, em, rem } from '../../utils/styles'

const CallToActionWrapper = styled.div`
  border-radius: ${rem(10)};
  padding: ${em(20)} ${em(20)};
  background-color: ${color('secondaryLight')};
  text-align: center;

  p {
    font-size: ${em(20)};
    margin: 0 0 1em;
  }
`

export default CallToActionWrapper
